var _path, _rect, _path2, _path3, _path4, _rect2, _path5, _path6, _path7, _path8, _circle, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle2, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInterviewYellowIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 90,
  height: 90,
  "data-name": "Layer 1",
  viewBox: "0 0 833.222 633.11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f2f2f2",
  d: "M770.925 575.462c-27.3 20.79-60.56 41.85-93.26 51.78a132 132 0 0 1-29 5.61 87.7 87.7 0 0 1-27.45-2.13c-23.6-5.87-45.49-16.15-66.67-28.16-6.92-3.93-13.76-8.04-20.56-12.24-11.1-6.86-22.09-13.96-33.11-20.89-1.65-1.05-3.29-2.08-4.94-3.1h-.01q-3.99-2.505-8-4.94c-.47-.29-.94-.57-1.42-.86q-7.575-4.59-15.41-8.97c-.64-.35-1.28-.71-1.92-1.06a338 338 0 0 0-31.12-15.23c-6.98-2.94-14.05-5.59-21.19-7.85h-.01c-2.73-.86-5.47-1.67-8.22-2.41a172 172 0 0 0-25.14-4.92 137.5 137.5 0 0 0-35.21.28c-.79.11-1.57.22-2.36.35-31.6 5.06-60.44 22.12-92.18 26.14-1.03.13-2.05.25-3.08.34-.44.04-.88.09-1.32.12a126.2 126.2 0 0 1-27.68-.68c-25.63-3.38-50.59-13.87-73.06-27.09-52.53-30.91-95.13-78.42-121.03-133.44a298 298 0 0 1-11.83-28.93 278.5 278.5 0 0 1-15.67-84.85c-2.43-100.36 54.6-201.05 144.14-246.44 89.55-45.39 207.35-30.38 279.57 39.35 43.81 42.3 69.16 99.62 102.13 150.83 32.97 51.2 79.83 100.11 140.27 107.57 30.79 3.8 63.01-3.55 92.52 6.01 16.34 5.3 30.28 15.44 41.51 28.36a127.2 127.2 0 0 1 18.78 29 142 142 0 0 1 8.73 23.54c.41 1.49.79 2.98 1.16 4.47 14.7 60.04-8.79 122.98-57.96 160.44"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 145,
  height: 51,
  x: 159.665,
  y: 466.772,
  fill: "#3f3d56",
  rx: 25.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M250.665 504.772v42.43a125.6 125.6 0 0 1-29-.56v-41.87Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M348.285 520.372c-.79.11-1.57.22-2.36.35-31.6 5.06-60.44 22.12-92.18 26.14-1.03.13-2.05.25-3.08.34-.44.04-.88.09-1.32.12-7.75-7.59-15.5-15.67-22.78-24.04-3.95-4.53-7.77-9.15-11.36-13.83-9.32-12.08-17.22-24.5-22.44-36.7.53-5.85-3.11-19.38-4.85-29.74l-.01-.01c-.74-4.35-1.14-8.13-.77-10.56 2.12-14.02 13.57-12.41 17.09-26.15a77.5 77.5 0 0 1 10.11-7.11c.59-.35 1.19-.7 1.81-1.05l38.2-26.4 14.6 14.32 22.22 21.8 24.08 23.61-20.44 20.65s17.08 19.69 37.05 45.94c5.36 7.05 10.93 14.58 16.43 22.32"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M677.665 504.772v122.47a132 132 0 0 1-29 5.61v-128.08Z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 145,
  height: 51,
  x: 595.665,
  y: 494.772,
  fill: "#3f3d56",
  rx: 25.5
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb6b6",
  d: "M486.505 560.532q-7.575-4.59-15.41-8.97c-.64-.35-1.28-.71-1.92-1.06l3.44-1.47 9.28-3.99.09-.04.1.34Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M500.875 569.432c-1.65-1.05-3.29-2.08-4.94-3.1h-.01q-3.99-2.505-8-4.94c-.47-.29-.94-.57-1.42-.86q-7.575-4.59-15.41-8.97c-.64-.35-1.28-.71-1.92-1.06a338 338 0 0 0-31.12-15.23c-6.98-2.94-14.05-5.59-21.19-7.85h-.01l-5.61-9.39-25.25-42.29-5.55-9.29s-18.93 5.6-45.72 10.97c-9.75 1.96-20.53 3.88-31.84 5.5-12.09 1.72-24.77 3.09-37.37 3.75-6.01.32-12 .48-17.9.43-15.25-.1-29.9-1.53-42.73-4.93-4.28-4.02-17.18-9.49-26.42-14.5h-.01c-3.88-2.1-7.1-4.11-8.79-5.9-9.74-10.3-1.42-18.33-10.08-29.57a78 78 0 0 1 .63-12.34c.09-.68.18-1.37.29-2.07l2.73-46.36 20.28-2.68 30.86-4.08 33.43-4.42 3.68 28.82s26.03-1.32 59.01-.88c52.97.72 123.85 6 133.45 28.66.9 2.13 1.8 4.28 2.7 6.43q3.21 7.71 6.36 15.5c7.61 18.8 14.87 37.78 21.5 55.72 4.12 11.16 8 21.92 11.57 31.99a2795 2795 0 0 1 13.98 40.5c.28.83.55 1.65.82 2.44"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#a0616a",
  d: "m314.32 288.545-64.056-54.402 41.675-42.176 29.075 47.623 107.774 21.367a20.9 20.9 0 1 1-2.97 30.678Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M193.653 162.647c-7.402 24.083 63.1 81.52 63.1 81.52.783-5.782 40.756 44.073 43.475 39.558 7.73-12.832 16.234-44.552 25.157-48.606 5.103-2.318-24.17-34.543-24.17-34.543s-14.933-19.756-34.65-44.794a53.41 53.41 0 0 0-47.083-20.962s-18.426 3.744-25.829 27.827"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 224.825,
  cy: 66.009,
  r: 43.324,
  fill: "#a0616a"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M246.487 137.967c9.334 5.55 14.917 15.744 18.122 26.119a247.5 247.5 0 0 1 10.637 59.137l3.385 60.09 41.926 127.947c-36.336 30.746-172.919 6.987-172.919 6.987s-4.192-1.397 0-5.59 8.275-.478 4.082-4.67-1.302.478.095-3.715 0-1.398-1.397-2.795 10.819-13.976 10.819-13.976l-11.18-73.443-13.976-148.14c16.77-20.963 50.498-33.32 50.498-33.32l8.715-15.687 43.574 3.485Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M260.54 42.992a20.08 20.08 0 0 1 7.132 10.02 141 141 0 0 0 .093-19.66c-.511-4.601-3.75-5.636-7.5-6.835-3.388-1.083-7.219-2.307-8.25-6.774-13.618-13.248-37.325-12.58-53.55-7.959-8.927 2.543-14.064 5.81-14.524 7.724l-.095.394-.363.182c-6.881 3.44-8.22 14.306-8.132 22.815.167 16.031 5.703 34.239 8.82 35.718.166.078.208.048.28-.012 4.694-3.752 10.423.285 12.94 2.48a45.06 45.06 0 0 1 40.346-38.22 71 71 0 0 0 9.725-1.63 20.5 20.5 0 0 1 4.967-.652 14.14 14.14 0 0 1 8.11 2.409"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "m205.949 353.817-13.253-6.787a3.632 3.632 0 0 1 3.276-6.397l13.253 6.787a3.632 3.632 0 0 1-3.276 6.397"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#a0616a",
  d: "m161.346 335.633-21.801-81.162 58.259-11.029-3.133 55.71 76.547 78.818a20.9 20.9 0 1 1-19.875 23.558Z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M133.583 163.471c-19.775 15.612 5.607 102.935 5.607 102.935 3.93-4.312 8.496 59.425 13.3 57.255 13.65-6.168 38.672-27.438 48.318-25.704 5.516.991-.263-42.16-.263-42.16s-1.063-24.741-3.061-56.548a53.41 53.41 0 0 0-26.836-44.001s-17.29-7.388-37.065 8.223M818.995 387.012l-791.42-.9a298 298 0 0 1-11.83-28.93l784.47.83a127.2 127.2 0 0 1 18.78 29"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb6b6",
  d: "M566.925 596.832q-6.135 2.97-12.38 5.73c-6.92-3.93-13.76-8.04-20.56-12.24l25.22-11.08Z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M750.805 459.032q-6.15 8.25-12.69 16.17-6.03 7.305-12.38 14.33c-1.75 1.94-3.52 3.87-5.33 5.78q-4.995 5.355-10.21 10.53c-6.26 1.97-18.94 5.44-32.53 8.68-9.89 2.35-20.26 4.58-29 6a104.5 104.5 0 0 1-14.81 1.58c-5.9.05-11.89-.11-17.9-.43-6.78-.36-13.57-.92-20.28-1.64-17.45-1.83-34.35-4.68-48.93-7.61-5.34-1.06-10.36-2.14-14.98-3.19-8.75-1.97-16.07-3.81-21.37-5.21-5.97-1.56-9.37-2.57-9.37-2.57l-14.95 25.04-7.76 12.99-5.7 9.55-1.52 2.53c-.64-.35-1.28-.71-1.92-1.06a338 338 0 0 0-31.12-15.23c-6.98-2.94-14.05-5.59-21.19-7.85h-.01c-2.73-.86-5.47-1.67-8.22-2.41q1.29-3.465 2.61-6.98 2.46-6.555 5.02-13.23c3.69-9.64 7.51-19.42 11.44-29.15 3.22-7.99 6.5-15.95 9.82-23.8 1.53-3.62 4.64-6.8 8.99-9.59a52 52 0 0 1 6.49-3.48c12.45-5.67 30.79-9.36 51-11.73 1.67-.19 3.35-.38 5.04-.56 16.73-1.76 34.48-2.67 51.08-3.09 8.31-.21 16.33-.29 23.79-.3q3.615 0 7.03.02h.01c6.15.03 11.81.12 16.79.22.97.02 1.91.05 2.83.07h.01c.62.01 1.23.03 1.83.04 10.89.28 17.57.62 17.57.62l2.59-20.32.53-4.1.5-3.9v-.01l.06-.49.41-.01 7.2-.14 60.52-1.18 33.06-.65-5.24 22.46-8.65 37.06c.88 5.86 30.14 1.27 29.84 6.24"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M574.385 593.132c-2.47 1.26-4.96 2.5-7.46 3.7q-6.135 2.97-12.38 5.73c-6.92-3.93-13.76-8.04-20.56-12.24-11.1-6.86-22.09-13.96-33.11-20.89-1.65-1.05-3.29-2.08-4.94-3.1h-.01c-4.54-6.74-9.17-13.76-13.84-20.99-.07-.1-.13-.2-.19-.3q-1.8-2.76-3.58-5.56c-7.47-11.7-14.98-23.9-22.27-36.36l18.46-8.62 34.32-16.02 5.92-2.76 17.02 33.51 15.18 29.89 3.38 6.65Z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb8b8",
  d: "m579.557 432.25 87.5-84.384 24.253-68.67-35.773-15.555c-18.374 17.601-38.236 72.424-38.236 72.424l-60.213 76.605c-.47.16-.937.331-1.4.535a17.231 17.231 0 1 0 23.87 19.045"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "m645.471 271.308 45.376 14.405.17-.028c16.89-2.83 30.903-30.413 39.685-53.054a31.596 31.596 0 0 0-16.087-40.024 31.67 31.67 0 0 0-33.165 4.184l-23.3 19.04Z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "m750.623 460.045.265-.352c14.157-18.777-5.206-65.274-8.133-72.017l13.163-3.9-2.294-25.063-1.105-11.176 10.235-9.72.034-.248 7.039-50.092 9.21-33.154a73.29 73.29 0 0 0-18.96-71.535l-18.828-18.693-22.557-35.306-37.819-.977-13.6 24.16a55.14 55.14 0 0 0-44.103 55.178l1.28 64.315-13.57 79.688-.38 14.474-13.32 14.056 2.463 14.21-9.963 3.968-4.876 20.191c-1.862 2.33-14.156 17.87-14.268 22.203-.016.65.447 1.291 1.46 2.015 7.958 5.694 52.437 18.031 72.456 10.614 21.323-7.894 104.894 6.932 105.736 7.083Z"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 696.48,
  cy: 66.885,
  r: 50.104,
  fill: "#ffb8b8"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M690.367 117.66a136 136 0 0 0 23.18-1.62c7.6-1.546 24.6-14.004 29.34-21.5 3.52-5.57 5.772-14.268 7.041-20.583a60.91 60.91 0 0 0-10.654-48.359 19.25 19.25 0 0 0-7.773-6.634 10 10 0 0 0-.854-.288 23.75 23.75 0 0 1-11.812-7.309 19.6 19.6 0 0 0-1.964-2.02 29.25 29.25 0 0 0-12.202-6.128c-7.254-1.941-17.752-.014-31.202 5.734-6.758 2.887-14.148 1.842-19.833.609a1.86 1.86 0 0 0-1.751.6 13.13 13.13 0 0 1-8.925 3.558c-2.032.089-4.164 2.902-6.74 6.571-.585.833-1.268 1.805-1.76 2.397l-.066-1.136-1.15 1.267a15.935 15.935 0 0 0 7.195 25.96 31 31 0 0 0 6.25.997c1.28.115 2.603.234 3.87.454a24.03 24.03 0 0 1 17.853 15.59 6.283 6.283 0 0 0 9.483 3.05 10.38 10.38 0 0 1 9.46-1.722 6.9 6.9 0 0 1 3.045 3.455 9 9 0 0 0 3.408 3.976c5.15 2.655 5.505 14.417 3.655 24.222-1.783 9.451-5.307 16.288-8.57 16.626-2.512.26-2.8.439-2.981.883l-.163.397.283.372a10.3 10.3 0 0 0 4.337.58"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb8b8",
  d: "m657.913 256.16-19.318-38.515c-28.041 1.915-83.695 34.337-83.695 34.337l-105.299 22.325a19.023 19.023 0 1 0 5.187 32.509l133.946-9.602Z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "m650.122 262.484 50.453-37.494 8.888-32.027a34.98 34.98 0 0 0-10.522-35.395 34.9 34.9 0 0 0-47.624 1.537c-18.986 18.951-40.641 45.39-35.99 63.723l.047.186Z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M452.665 362.772h135v18h-135zM107.665 362.772h135v18h-135z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M258.429 276.21v85.704a4.12 4.12 0 0 0 4.119 4.12h127.004a4.12 4.12 0 0 0 4.12-4.12V276.21a4.124 4.124 0 0 0-4.12-4.114H262.548a4.124 4.124 0 0 0-4.12 4.114"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "M261.408 277.277v83.58a2.205 2.205 0 0 0 2.202 2.202h124.885a2.205 2.205 0 0 0 2.201-2.202v-83.58a2.206 2.206 0 0 0-2.2-2.206H263.61a2.206 2.206 0 0 0-2.202 2.206"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M255.773 378.629a2.47 2.47 0 0 0 1.943.93h135.992a2.502 2.502 0 0 0 2.446-3.016l-2.11-10.027a2.5 2.5 0 0 0-1.559-1.818 2.4 2.4 0 0 0-.888-.168H259.819a2.4 2.4 0 0 0-.888.168 2.5 2.5 0 0 0-1.558 1.818l-2.111 10.027a2.5 2.5 0 0 0 .51 2.086"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 569.832,
  y: 499.781,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 480.231 434.315)"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 561.455,
  y: 499.781,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 471.854 434.315)"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 553.078,
  y: 499.781,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 463.477 434.315)"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 544.701,
  y: 499.781,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 455.1 434.315)"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 536.324,
  y: 499.781,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 446.723 434.315)"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 527.947,
  y: 499.781,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 438.346 434.315)"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 519.57,
  y: 499.781,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 429.97 434.315)"
})), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 511.193,
  y: 499.781,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 421.592 434.315)"
})), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 502.816,
  y: 499.781,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 413.215 434.315)"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 494.439,
  y: 499.781,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 404.838 434.315)"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 486.062,
  y: 499.781,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 396.461 434.315)"
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 477.685,
  y: 499.781,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 388.084 434.315)"
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 469.308,
  y: 499.781,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 379.708 434.315)"
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 460.931,
  y: 499.781,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 371.33 434.315)"
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 452.554,
  y: 499.781,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 362.954 434.315)"
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 444.177,
  y: 499.781,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 354.577 434.315)"
})), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 569.931,
  y: 503.97,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 480.33 438.504)"
})), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 561.554,
  y: 503.97,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 471.953 438.504)"
})), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 553.177,
  y: 503.97,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 463.576 438.504)"
})), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 544.8,
  y: 503.97,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 455.2 438.504)"
})), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 536.423,
  y: 503.97,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 446.822 438.504)"
})), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 528.046,
  y: 503.97,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 438.445 438.504)"
})), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 519.669,
  y: 503.97,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 430.068 438.504)"
})), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 511.292,
  y: 503.97,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 421.691 438.504)"
})), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 502.915,
  y: 503.97,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 413.314 438.504)"
})), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 494.538,
  y: 503.97,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 404.937 438.504)"
})), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 486.161,
  y: 503.97,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 396.56 438.504)"
})), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 477.784,
  y: 503.97,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 388.183 438.504)"
})), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 469.407,
  y: 503.97,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 379.806 438.504)"
})), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 461.03,
  y: 503.97,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 371.43 438.504)"
})), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 452.653,
  y: 503.97,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 363.053 438.504)"
})), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
  width: 4.188,
  height: 2.513,
  x: 444.276,
  y: 503.97,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 354.676 438.504)"
})), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
  width: 33.508,
  height: 2.513,
  x: 500.402,
  y: 508.996,
  fill: "#3f3d56",
  rx: 0.488,
  transform: "rotate(-180 425.461 443.53)"
})));
export default SvgInterviewYellowIcon;